import CustomValueContainer from 'components/common/Dropdown/CustomValueContainer'
import VirtualOptionsList from 'components/common/VirtualOptionsList/VirtualOptionsList'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSDropdown, {
  DropdownVariant,
} from 'designSystem/components/PDSDropdown/PDSDropdown'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSTag from 'designSystem/components/PDSTag/PDSTag'
import { SIZE } from 'designSystem/foundations/constants/size'

export type ExclusionDropdownOption<T = string> = {
  label: string
  value: T
  isDisabled?: boolean
}

export type DropdownOptionNumber = {
  label: string
  value: number
  isDisabled?: boolean
}

type Props = {
  id?: string
  isDisabled?: boolean
  label?: string
  onChange?: (values: any) => void
  options: ExclusionDropdownOption[]
  placeholder?: string
  testId?: string
  value?: string[]
  variant?: DropdownVariant
}

export default function ExclusionsDropdown({
  isDisabled = false,
  options,
  label = '',
  onChange,
  placeholder = '',
  testId,
  value = [],
  ...props
}: Props) {
  const selectedOptions = options.filter((o) => value.includes(o.value))

  const handleChange = (values: unknown) => {
    onChange?.((values as ExclusionDropdownOption[]).map((o) => o.value))
  }

  const handleRemove = (option: ExclusionDropdownOption) => {
    const newVals = selectedOptions.filter((o) => o.value !== option.value)
    handleChange(newVals)
  }

  return (
    <PDSBox>
      <PDSDropdown
        components={{
          DropdownIndicator: null,
          MenuList: VirtualOptionsList,
          ValueContainer: CustomValueContainer,
        }}
        controlShouldRenderValue={false}
        isDisabled={isDisabled}
        isMulti
        label={label}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        testId={testId}
        value={selectedOptions}
        styles={{
          input: (base: any) => ({
            ...base,
            marginLeft: 24,
          }),
          placeholder: (base: any) => ({
            ...base,
            marginLeft: 24,
          }),
        }}
        {...props}
      />

      {selectedOptions && selectedOptions.length > 0 && (
        <PDSFlexBox
          width="100%"
          flexWrap="wrap"
          gap={SIZE.s8}
          marginBottom={SIZE.s8}
          marginTop={SIZE.s8}
        >
          {selectedOptions.map((option: ExclusionDropdownOption) => (
            <PDSTag
              key={option.value}
              canClose={!isDisabled}
              onClose={() => handleRemove(option)}
              testId={testId && `${testId}-${option.label.toLowerCase()}`}
              variant="alert"
            >
              {option.label}
            </PDSTag>
          ))}
        </PDSFlexBox>
      )}
    </PDSBox>
  )
}
